<kiwi-simulated-periods-selector class="cell shrink"></kiwi-simulated-periods-selector>

<table class="_tableColor" *ngIf="teamsTotalMarks">
    <thead>
        <tr class="_titlePartTable">
            <th [i18nKey]="'common.team'"></th>
            <th *ngIf="displayTreasuryMark()" class="_numberColumn"[i18nKey]="'evaluations.final.mark.criteria.treasury.mark.weight'"></th>
            <th *ngIf="displayProfitabilityMark()" class="_numberColumn"[i18nKey]="'evaluations.final.mark.criteria.profitability.mark.weight'"></th>
            <th *ngIf="displayCustomerSatisfactionMark()" class="_numberColumn"[i18nKey]="'evaluations.final.mark.criteria.customer.satisfaction.mark.weight'"></th>
            <th class="_numberColumn"[i18nKey]="'evaluations.tabs.FINAL_MARK'"></th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let teamTotalMarks of teamsTotalMarks.teamMarks">
            <td>
                {{teamTotalMarks.teamName}}
            </td>
            <td *ngIf="displayTreasuryMark()" class="_number">
                {{teamTotalMarks.marks.treasuryMark.displayMark}}
            </td>
            <td *ngIf="displayProfitabilityMark()" class="_number">
                {{teamTotalMarks.marks.profitabilityMark.displayMark}}
            </td>
            <td *ngIf="displayCustomerSatisfactionMark()" class="_number">
                {{teamTotalMarks.marks.customerSatisfactionMark.displayMark}}
            </td>
            <td class="_number">
                {{teamTotalMarks.marks.displayTotalMark}}
            </td>
        </tr>
    </tbody>
</table>
